import { uniqBy } from 'lodash-es'
import makeMapper from '../mappers/string-to-object'

const mapper = makeMapper(['value', 'label'])

const collections_os_types = {
	key: 'collections.os-types',

	fn() {
		return {
			depends: ['collections.oss'],

			normalizer(_, [oss]) {
				const fn = ({ osName }) => osName
				const data = uniqBy(oss, fn).map(fn)

				return data.map(mapper)
			},
		}
	},
}

export { collections_os_types as default }
